import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowPreviousLeftIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	shapeRendering: "geometricPrecision",
	textRendering: "geometricPrecision",
	imageRendering: "optimizeQuality",
	fillRule: "evenodd",
	clipRule: "evenodd",
	viewBox: "0 0 319 511.61",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m270.08 5.89 43.04 43.04c7.85 7.86 7.83 20.72 0 28.54L134.77 255.82l178.35 178.35c7.85 7.86 7.8 20.73 0 28.54l-43.04 43.04c-7.83 7.82-20.71 7.82-28.54 0L49.29 313.49l-.37-.36-43.04-43.04c-7.82-7.83-7.86-20.68 0-28.54l43.04-43.04.37-.36L241.54 5.89c7.85-7.85 20.68-7.85 28.54 0z" })
});
export default SvgArrowPreviousLeftIcon;
